var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "span",
    {
      class:
        "quicksearch_container" +
        (_vm.containerclass ? " " + _vm.containerclass : ""),
    },
    [
      !_vm.autocomplete && _vm.name
        ? _c("input", {
            attrs: {
              type: "hidden",
              name: _vm.name,
            },
            domProps: {
              value: _vm.returnValue,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            attrs: {
              type: "text",
              name: _vm.autocomplete ? _vm.name : null,
              autocomplete: "off",
            },
            domProps: {
              value: _vm.inputValue,
            },
            on: {
              blur: function blur($event) {
                return _vm.reset()
              },
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp",
                    ])
                  ) {
                    return null
                  }
                  return _vm.selectUp.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown",
                    ])
                  ) {
                    return null
                  }
                  return _vm.selectDown.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.selectByKey.apply(null, arguments)
                },
              ],
              input: function input($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputValue = $event.target.value
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdownmenu",
        },
        [
          _vm.isVisible
            ? _c(
                "ul",
                {
                  staticClass: "autocomplete__results",
                },
                [
                  _vm._l(_vm.results, function (result, index) {
                    return _c("li", {
                      key: index,
                      staticClass: "autocomplete__result",
                      class:
                        index === _vm.selected
                          ? "autocomplete__result--selected"
                          : "",
                      domProps: {
                        innerHTML: _vm._s(result.item_name),
                      },
                      on: {
                        click: function click($event) {
                          return _vm.select(result)
                        },
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.errorMessage !== null
                    ? _c("li", [_vm._v(_vm._s(_vm.errorMessage))])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }